import { render, staticRenderFns } from "./AddTextTemplate.vue?vue&type=template&id=7ecb5572&scoped=true"
import script from "./AddTextTemplate.vue?vue&type=script&lang=js"
export * from "./AddTextTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecb5572",
  null
  
)

export default component.exports